module.exports = __webpack_public_path__ + "img/arrow_down_square.acc2075b.svg";